// extracted by mini-css-extract-plugin
module.exports = {"chart_card":"ChartCard_chart_card__3Zrec","chart_card_title":"ChartCard_chart_card_title__duDmH","chart_card_content":"ChartCard_chart_card_content__1UMz9"};